!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("html2canvas"), require("jspdf")) : "function" == typeof define && define.amd ? define(["html2canvas", "jspdf"], e) : "object" == typeof exports ? exports["jspdf-html2canvas"] = e(require("html2canvas"), require("jspdf")) : t.html2PDF = e(t.html2canvas, t.jspdf);
}(window, function (t, e) {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 6);
  }([function (t, e, r) {
    t.exports = r(5);
  }, function (e, r) {
    e.exports = t;
  }, function (t, e) {
    function r(t, e, r, n, o, i, a) {
      try {
        var c = t[i](a),
            u = c.value;
      } catch (t) {
        return void r(t);
      }

      c.done ? e(u) : Promise.resolve(u).then(n, o);
    }

    t.exports = function (t) {
      return function () {
        var e = this,
            n = arguments;
        return new Promise(function (o, i) {
          var a = t.apply(e, n);

          function c(t) {
            r(a, o, i, c, u, "next", t);
          }

          function u(t) {
            r(a, o, i, c, u, "throw", t);
          }

          c(void 0);
        });
      };
    };
  }, function (t, r) {
    t.exports = e;
  }, function (t, e) {
    function r(e) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = r = function r(t) {
        return typeof t;
      } : t.exports = r = function r(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, r(e);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = function (t) {
      "use strict";

      var e = Object.prototype,
          r = e.hasOwnProperty,
          n = "function" == typeof Symbol ? Symbol : {},
          o = n.iterator || "@@iterator",
          i = n.asyncIterator || "@@asyncIterator",
          a = n.toStringTag || "@@toStringTag";

      function c(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }

      try {
        c({}, "");
      } catch (t) {
        c = function c(t, e, r) {
          return t[e] = r;
        };
      }

      function u(t, e, r, n) {
        var o = e && e.prototype instanceof l ? e : l,
            i = Object.create(o.prototype),
            a = new P(n || []);
        return i._invoke = function (t, e, r) {
          var n = "suspendedStart";
          return function (o, i) {
            if ("executing" === n) throw new Error("Generator is already running");

            if ("completed" === n) {
              if ("throw" === o) throw i;
              return L();
            }

            for (r.method = o, r.arg = i;;) {
              var a = r.delegate;

              if (a) {
                var c = b(a, r);

                if (c) {
                  if (c === s) continue;
                  return c;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw n = "completed", r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var u = f(t, e, r);

              if ("normal" === u.type) {
                if (n = r.done ? "completed" : "suspendedYield", u.arg === s) continue;
                return {
                  value: u.arg,
                  done: r.done
                };
              }

              "throw" === u.type && (n = "completed", r.method = "throw", r.arg = u.arg);
            }
          };
        }(t, r, a), i;
      }

      function f(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = u;
      var s = {};

      function l() {}

      function p() {}

      function h() {}

      var d = {};

      d[o] = function () {
        return this;
      };

      var g = Object.getPrototypeOf,
          m = g && g(g(k([])));
      m && m !== e && r.call(m, o) && (d = m);
      var y = h.prototype = l.prototype = Object.create(d);

      function v(t) {
        ["next", "throw", "return"].forEach(function (e) {
          c(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }

      function w(t, e) {
        var n;

        this._invoke = function (o, i) {
          function a() {
            return new e(function (n, a) {
              !function n(o, i, a, c) {
                var u = f(t[o], t, i);

                if ("throw" !== u.type) {
                  var s = u.arg,
                      l = s.value;
                  return l && "object" == typeof l && r.call(l, "__await") ? e.resolve(l.__await).then(function (t) {
                    n("next", t, a, c);
                  }, function (t) {
                    n("throw", t, a, c);
                  }) : e.resolve(l).then(function (t) {
                    s.value = t, a(s);
                  }, function (t) {
                    return n("throw", t, a, c);
                  });
                }

                c(u.arg);
              }(o, i, n, a);
            });
          }

          return n = n ? n.then(a, a) : a();
        };
      }

      function b(t, e) {
        var r = t.iterator[e.method];

        if (void 0 === r) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = void 0, b(t, e), "throw" === e.method)) return s;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return s;
        }

        var n = f(r, t.iterator, e.arg);
        if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, s;
        var o = n.arg;
        return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, s) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, s);
      }

      function x(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function j(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function P(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(x, this), this.reset(!0);
      }

      function k(t) {
        if (t) {
          var e = t[o];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var n = -1,
                i = function e() {
              for (; ++n < t.length;) {
                if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
              }

              return e.value = void 0, e.done = !0, e;
            };

            return i.next = i;
          }
        }

        return {
          next: L
        };
      }

      function L() {
        return {
          value: void 0,
          done: !0
        };
      }

      return p.prototype = y.constructor = h, h.constructor = p, p.displayName = c(h, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === p || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : (t.__proto__ = h, c(t, a, "GeneratorFunction")), t.prototype = Object.create(y), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, v(w.prototype), w.prototype[i] = function () {
        return this;
      }, t.AsyncIterator = w, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new w(u(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, v(y), c(y, a, "Generator"), y[o] = function () {
        return this;
      }, y.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e.reverse(), function r() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, t.values = k, P.prototype = {
        constructor: P,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(j), !t) for (var e in this) {
            "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function n(r, n) {
            return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
                a = i.completion;
            if ("root" === i.tryLoc) return n("end");

            if (i.tryLoc <= this.prev) {
              var c = r.call(i, "catchLoc"),
                  u = r.call(i, "finallyLoc");

              if (c && u) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              } else if (c) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];

            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, s) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), s;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), s;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                j(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, r) {
          return this.delegate = {
            iterator: k(t),
            resultName: e,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), s;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = n;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    var n = r(0),
        o = r.n(n),
        i = r(2),
        a = r.n(i),
        c = r(3),
        u = r(1),
        f = r.n(u),
        s = {
      jsPDF: {
        unit: "px",
        format: "a4"
      },
      html2canvas: {
        imageTimeout: 15e3,
        logging: !0,
        useCORS: !1
      },
      margin: {
        right: 0,
        top: 0,
        bottom: 0,
        left: 0
      },
      imageType: "image/jpeg",
      imageQuality: 1,
      output: "jspdf-generate.pdf",
      init: function init() {},
      success: function success(t) {
        t.save(this.output);
      }
    },
        l = r(4),
        p = r.n(l);

    function h(t) {
      return null !== t && "object" === p()(t);
    }

    function d(t) {
      return "function" == typeof t;
    }

    function g(t, e) {
      for (var r = 0, n = Object.keys(t); r < n.length; r++) {
        var o = n[r];

        if (o in e) {
          var i = h(t[o]),
              a = h(e[o]);
          i && a ? d(t[o]) && d(e[o]) ? d(t[o]) && !d(e[o]) ? console.error('[jspdf-html2canvas] config key "'.concat(o, '" type invalid')) : t[o] = e[o] : t[o] = g(t[o], e[o]) : a ? (e[o].old = t[o], t[o] = e[o]) : i ? t[o].new = e[o] : t[o] = e[o], delete e[o];
        }
      }

      return Object.assign(t, e);
    }

    function m(t) {
      var e = t.margin,
          r = new c.jsPDF(t.jsPDF),
          n = r.internal.pageSize.getWidth(),
          o = r.internal.pageSize.getHeight();
      return {
        pdf: r,
        pdfWidth: n,
        pdfHeight: o,
        pdfContentWidth: n - (e.left + e.right),
        pdfContentHeight: o - (e.top + e.bottom),
        position: 0,
        currentPage: 1,
        pageOfCurrentNode: 1
      };
    }

    function y(t, e, r) {
      var n = e.pdf,
          o = e.pdfContentWidth,
          i = e.pdfContentHeight,
          a = e.pdfWidth,
          c = e.pdfHeight,
          u = e.position,
          f = e.currentPage,
          s = e.pageOfCurrentNode,
          l = function (t) {
        var e = t.canvas,
            r = t.pdf,
            n = t.pdfContentWidth,
            o = t.opts,
            i = e.toDataURL(o.imageType, o.imageQuality),
            a = r.getImageProperties(i);
        return {
          pageData: i,
          imgHeight: n / a.width * a.height
        };
      }({
        canvas: t,
        pdf: n,
        pdfContentWidth: o,
        opts: r
      }),
          p = l.pageData,
          h = l.imgHeight,
          d = h;

      u < 0 && (n.addPage(), f += 1, s = 1, u = 0);

      for (var g = r.margin; d > 0;) {
        if (n.addImage(p, {
          "image/jpeg": "JPEG",
          "image/png": "PNG",
          "image/webp": "WEBP"
        }[r.imageType], g.left, u + g.top * s + g.bottom * (s - 1), o, h), n.setFillColor(255, 255, 255), n.rect(0, 0, a, g.top, "F"), n.rect(0, c - g.bottom, a, g.bottom, "F"), d < i) {
          u -= d;
          break;
        }

        d -= i, u -= c, n.addPage(), f += 1, s += 1;
      }

      return e.pdf = n, e.position = u, e.currentPage = f, e.pageOfCurrentNode = s, {
        pdf: n,
        position: u
      };
    }

    function v(t, e) {
      var r = t.internal.getNumberOfPages();
      if (e.watermarkImg) for (var n = t.getImageProperties(e.watermarkImg), o = e.watermark.scale || 1, i = 1; i <= r; i++) {
        if (t.setPage(i), e.watermark.src && e.watermark.handler) {
          var a = {
            pdf: t,
            pageNumber: i,
            totalPageNumber: r,
            imgNode: e.watermarkImg
          };
          e.watermark.handler.call(e, a);
        } else t.addImage(e.watermarkImg, "PNG", (t.internal.pageSize.width - n.width * o) / 2, (t.internal.pageSize.height - n.height * o) / 2, n.width * o, n.height * o);
      } else if ("function" == typeof e.watermark) for (var c = 1; c <= r; c++) {
        t.setPage(c);
        var u = {
          pdf: t,
          pageNumber: c,
          totalPageNumber: r
        };
        e.watermark.call(e, u);
      } else console.warn('[jspdf-html2canvas] "watermark" option should be either "string" or "function" type.');
      return t;
    }

    function w(t, e) {
      var r = new Image(),
          n = "string" == typeof t.watermark ? t.watermark : t.watermark.src;
      n ? (r.onload = function () {
        e(r);
      }, r.crossOrigin = "Anonymous", r.src = n) : e();
    }

    function b() {
      return (b = a()(o.a.mark(function t(e) {
        var r,
            n,
            i,
            a = arguments;
        return o.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (r = a.length > 1 && void 0 !== a[1] ? a[1] : {}, r = g(s, r), n = m(r), r.init.call(r, n.pdf), !e.length) {
                  t.next = 16;
                  break;
                }

                i = 0;

              case 6:
                if (!(i < e.length)) {
                  t.next = 14;
                  break;
                }

                return t.next = 9, f()(e[i], r.html2canvas);

              case 9:
                y(t.sent, n, r);

              case 11:
                i++, t.next = 6;
                break;

              case 14:
                t.next = 20;
                break;

              case 16:
                return t.next = 18, f()(e, r.html2canvas);

              case 18:
                y(t.sent, n, r);

              case 20:
                return r.watermark ? w(r, function (t) {
                  t && (r.watermarkImg = t), n.pdf = v(n.pdf, r), r.success.call(r, n.pdf);
                }) : r.success.call(r, n.pdf), t.abrupt("return", n.pdf);

              case 22:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    e.default = function (t) {
      return b.apply(this, arguments);
    };
  }]).default;
});